<div class="success">
  <button class="close-ios-inv" mat-button color="primary" (click)="close()">
    <span class="material-icons">close</span>
  </button>
  <div class="fullWidth flexCenter bottomBuffer padding">{{ message }}</div>
</div>
